import { useEffect, useRef } from 'react';

export const useImageLoadingCallback = (imageList: string[], callback: () => void) => {
  const loadedCount = useRef<number>(0);

  useEffect(() => {
    if (imageList.length == 0) {
      callback();
    }

    imageList.forEach((src) => {
      const img = new Image();
      const handler = () => {
        loadedCount.current += 1;
        if (loadedCount.current == imageList.length) {
          callback();
        }
      };
      img.onload = handler;
      img.onerror = handler;
      img.src = src;
    });
  }, []);
};
